var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"include":"ApplyEngineer"}},[_c('router-view')],1)],1),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }